
import Videos from "@/components/Videos";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

const TrainingVideos = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <div className="pt-8">
        <Videos />
      </div>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default TrainingVideos;
